<template>
    <v-tab-item :value="hall">
        <div v-for="item in items" :key="item._id" flat>
            <template v-if="item.showsProgram">
                <div class="mt-30 mb-6 mt-md-40 mb-md-10">
                    <h3 class="tit tit--xs">{{ item?.program?.subject || "-" }}</h3>
                </div>
                <v-divider class="primary" />
            </template>

            <div class="py-14">
                <v-row no-gutters>
                    <v-col cols="12" md="6" align-self="center">
                        <v-row no-gutters align="center">
                            <v-col cols="4">
                                <bids-item-imgs :imgs="item?.work?.imgs" />
                            </v-col>
                            <v-col cols="8">
                                <div class="pl-16 pl-md-20">
                                    <div class="d-flex flex-wrap align-center">
                                        <v-chip outlined small class="rounded-0 mr-8">{{ item?.work?.lot }}</v-chip>
                                        <strong class="font-size-16 font-size-md-18">{{ item?.work?.author?.name?.ko }}</strong>
                                    </div>
                                    <div class="mt-2 mt-md-4">
                                        <span class="font-size-14 font-size-md-16">{{ item?.work?.subject }}</span>
                                    </div>
                                    <div class="mt-8 mt-md-10">
                                        <div class="font-size-14 line-height-13 grey-68--text">{{ item?.work?.year }}<br />{{ item?.work?.material }} ㅣ {{ item?.work?.dimensionTag }}</div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="auto" class="d-none d-md-block" style="margin-left:-1px;">
                        <v-divider vertical class="grey-da"></v-divider>
                    </v-col>
                    <v-col cols="12" md="4">
                        <div class="font-size-14 py-10 pa-md-20 pl-md-40">
                            <v-row no-gutters align="baseline">
                                <v-col cols="3">
                                    <span>시작가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="grey-68--text pl-sm-12">KRW {{ item?.work?.price_auction?.from?.format?.() }}</div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="baseline" class="font-weight-medium mt-2 mt-md-4">
                                <v-col cols="3">
                                    <span>응찰가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="pl-sm-12">
                                        KRW {{ item?.price?.format?.() }}
                                        <span v-if="item?._id == item?.work?.price_auction?._bid ">
                                            [{{item?.work?.isAuctionEnded ? '낙찰' : '최고가'}}]
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="baseline" class="mt-2 mt-md-4">
                                <v-col cols="3">
                                    <span>낙찰가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="grey-68--text pl-sm-12">KRW {{ item?.work?.price_auction?.current?.format?.() }}</div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="baseline" class="mt-2 mt-md-4">
                                <v-col cols="3">
                                    <span>응찰일자</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="grey-68--text pl-sm-12">{{ item?.createdAt?.toDateTime?.() }}</div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-col cols="auto" class="d-none d-md-block" style="margin-left:-1px;">
                        <v-divider vertical class="grey-da"></v-divider>
                    </v-col>
                    <v-col cols="12" md="2" align-self="center" class="text-center">
                        <auction-bids v-if="type == 'all'" :bids="item.work.bids">
                            <template #activator="{attrs,on}">
                                <v-btn v-bind="attrs" v-on="on" small color="primary">응찰기록</v-btn>
                            </template>
                        </auction-bids>
                        <auction-won-notice v-if="type == 'won'" v-bind="{ program: item.program, bids: [item], user }">
                            <template #activator="{attrs,on}">
                                <v-btn v-bind="attrs" v-on="on" small color="primary" class="px-md-6"><span class="font-size-14">낙찰결과 통보서 보기</span></v-btn>
                            </template>
                        </auction-won-notice>
                    </v-col>
                </v-row>
            </div>
            <v-divider class="grey-da"></v-divider>
            <template v-if="type == 'won'">
                <div class="pa-12 d-flex align-center justify-center grey-ef">
                    <span class="font-size-14 font-size-md-16 grey-68--text">
                        총 결제금액: <span class="font-weight-medium primary--text">{{ item?.work?.price_auction.total?.format?.() }}원 + (배송비: {{ delivery }}원)</span>
                    </span>
                </div>
                <v-divider class="grey-da"></v-divider>
            </template>
        </div>

        <div class="v-pagination-wrap">
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" @input="search()" />
        </div>

        <v-fade-transition>
            <v-overlay v-show="loading" absolute light color="white">
                <v-progress-circular indeterminate size="100" width="3" color="black" />
            </v-overlay>
        </v-fade-transition>
    </v-tab-item>
</template>

<script>
import BidsItemImgs from "./bids-item-imgs.vue";
import AuctionBids from "../auction/auction-bids.vue";
import AuctionWonNotice from "../auction/auction-won-notice.vue";

import api from "@/api";
import { AUCTION_PROGRAM_HALLS, DELIVERY_POLICIES_DOMESTIC } from "@/assets/variables";

export default {
    components: {
        BidsItemImgs,
        AuctionBids,
        AuctionWonNotice,
    },
    props: {
        hall: { type: String, default: AUCTION_PROGRAM_HALLS.AUCTION_A.value },
        limit: { type: Number, default: 10 },
    },
    data() {
        return {
            loading: false,

            filter: {},
            totalCount: 0,
            page: this.$route.query.page || 1,

            bids: [],
            user: null,
        };
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        params() {
            const { hall, type } = this;
            return { ...this.filter, hall, type };
        },
        items() {
            return this.bids.map((bid, index) => ({ ...bid, showsProgram: bid._program !== this.bids?.[index - 1]?._program }));
        },
        type() {
            return this.$route.params?.type;
        },
        delivery() {
            const { address1 = "" } = this.user || {};
            if (address1 == "") return 0;

            const policy = DELIVERY_POLICIES_DOMESTIC.find(({ test }) => test(address1));
            return policy?.value?.format?.();
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        "$route.params.tab"() {
            this.init();
        },
        "$route.params.type"() {
            this.init();
        },
    },
    methods: {
        init() {
            if (this.$route.params.tab == this.hall) this.search(false);
        },
        async search(routable = true) {
            this.loading = true;
            const { page, skip, limit, params } = this;
            if (routable) this.$router.push({ query: Object.assign({}, this.filter, { page }) });

            var {
                summary: { totalCount },
                bids,
            } = await api.v1.me.bids.gets({ headers: { skip, limit }, params });

            this.bids = bids;
            this.totalCount = totalCount;

            if (this.type == "won") {
                const { user } = await api.v1.me.get();
                this.user = user;
            }

            this.loading = false;
        },
    },
};
</script>

<style></style>
